import React from 'react';

const HeadingH3 = (props) => {

    const { size, weight, color } = props;

    let className= '';
    className += 'u-fontSize' + size;
    className += ' u-fontWeight' + weight;
    className += ' u-textColor' + color;

    return (
        <h3 className={className}>{props.children}</h3>
    );
}

export default HeadingH3;


// WEBPACK FOOTER //
// ./src/components/UI/Headings/HeadingH3/HeadingH3.js